import { gql } from '@apollo/client';

const TOGGLE_USE_IN_RECOMMENDATIONS = gql`
  mutation toggleUseInRecommendations(
    $id: String!
    $type: String!
    $includeInRecommendations: Boolean!
  ) {
    toggleUseInRecommendations(
      id: $id
      type: $type
      includeInRecommendations: $includeInRecommendations
    ) {
      success
    }
  }
`;

export default TOGGLE_USE_IN_RECOMMENDATIONS;
